import ImageSection from './ImageSection.component';

export default ImageSection;